<template>
  <li v-if="asset" class="c-version__asset-item u-mb0 u-mt-0">
    <div class="c-version__assets-title">
      <!-- show platform if asset platform is not OTHER -->
      <h3 class="c-version__assets-name">{{ (asset.platform != '3' && asset.platform != '4') ? (asset.name ? asset.name : asset.filename) + ' - ' + assetPlatformName : (asset.name ? asset.name : asset.filename) }}</h3>
      <template v-if="isLogged">
        <!-- if asset is a file -->
        <template v-if="isFileAsset">
          <div v-if="asset.size && isFileAsset" class="c-version__assets-data c-version__assets-size u-mlxs">
            <code class="no-bg">
              <span class="u-color-disabled"> ({{ formatBytes(asset.size) }})</span>
            </code>
          </div>
          <!-- check if local or staging/prod and set asset.url or asset.file accordingly -->
          <!-- if user is from ircam -->
          <template v-if="isAdminUser || isInternalUser || (isPremiumUser && isInternalUser) || isVipUser">
            <div class="c-version__assets-download-container">
              <div v-if="isProjectOwner || isAdminUser" class="c-version__assets-data">
                <code class="no-bg">
                  <span class="u-color-disabled"> from 2023/02/16: </span>
                </code>
              </div>
              <code v-if="isProjectOwner || isAdminUser" class="c-version__assets-download-count">{{ assetDownloadCount }}</code>
              <a :href="assetUrl" class="c-version__assets-download-button matomo_download" download>
                <button type="button" class="c-button c-button--small" @click="updateDownloadCount">
                  <span class="c-button__label c-version__assets-button-label u-mrs">Download</span>
                  <i class="c-version__assets-download-icon fa fa-download" aria-hidden="true" />
                </button>
              </a>
            </div>
          </template>
          <!-- if user is premium -->
          <template v-if="isPremiumUser && !isInternalUser && !isVipUser">
            <!-- if project is free -->
            <div v-if="!isPremiumProject && !isProtectedProject" class="c-version__assets-download-container">
              <div v-if="isProjectOwner || isAdminUser" class="c-version__assets-data">
                <code class="no-bg">
                  <span class="u-color-disabled"> from 2023/02/16: </span>
                </code>
              </div>
              <code v-if="isProjectOwner || isAdminUser" class="c-version__assets-download-count">{{ assetDownloadCount }}</code>
              <a :href="assetUrl" class="c-version__assets-download-button matomo_download" download>
                <button type="button" class="c-button c-button--small" @click="updateDownloadCount">
                  <span class="c-version__assets c-button__asset-label u-mrs">Download</span>
                  <i class="c-version__assets-download-icon fa fa-download" aria-hidden="true" />
                </button>
              </a>
            </div>
            <!-- if project is premium -->
            <div v-else-if="isPremiumProject" class="c-version__assets-download-container">
              <div v-if="isProjectOwner || isAdminUser" class="c-version__assets-data">
                <code class="no-bg">
                  <span class="u-color-disabled"> from 2023/02/16: </span>
                </code>
              </div>
              <code v-if="isProjectOwner || isAdminUser" class="c-version__assets-download-count">{{ assetDownloadCount }}</code>
              <a :href="assetUrl" class="c-version__assets-download-button matomo_download" download>
                <button type="button" class="c-button c-button--small" @click="updateDownloadCount">
                  <span class="c-version__assets c-button__asset-label u-mrs">Download</span>
                  <i class="c-version__assets-download-icon fa fa-download" aria-hidden="true" />
                </button>
              </a>
            </div>
            <!-- if project is protected, asset download is authorized -->
            <template v-else-if="asset.authorized_download && isProtectedProject && (isPremiumUser || isVipUser)">
              <div class="c-version__assets-download-container">
                <div v-if="isProjectOwner || isAdminUser" class="c-version__assets-data">
                  <code class="no-bg">
                    <span class="u-color-disabled"> from 2023/02/16: </span>
                  </code>
                </div>
                <code v-if="isProjectOwner || isAdminUser" class="c-version__assets-download-count">{{ assetDownloadCount }}</code>
                <a :href="assetUrl" class="c-version__assets-download-button matomo_download" download>
                  <button type="button" class="c-button c-button--small" @click="updateDownloadCount">
                    <span class="c-button__label c-version__assets-button-label u-mrs">Download</span>
                    <i class="c-version__assets-download-icon fa fa-download" aria-hidden="true" />
                  </button>
                </a>
              </div>
            </template>
          </template>
          <!-- if user is not premium -->
          <template v-if="!isPremiumUser && !isInternalUser && !isVipUser && !isAdminUser">
            <!-- if project is premium and asset is free download -->
            <template v-if="asset.asset_meta!.free_download">
              <!-- if project is premium and asset is not premium and is asset meta free download and user is not internal/premium/vip -->
              <a v-if="isPremiumProject && !asset.is_premium && (!isPremiumUser && !isInternalUser && !isVipUser)" href="/subscribe/?subscription=upgrade" class="c-version__assets-download-button">
                <div v-if="isProjectOwner || isAdminUser" class="c-version__assets-data">
                  <code class="no-bg">
                    <span class="u-color-disabled"> from 2023/02/16: </span>
                  </code>
                </div>
                <code v-if="isProjectOwner || isAdminUser" class="c-version__assets-download-count">{{ assetDownloadCount }}</code>
                <a :href="assetUrl" class="c-version__assets-download-button matomo_download" download>
                  <button type="button" class="c-button c-button--small" @click="updateDownloadCount">
                    <span class="c-version__assets c-button__asset-label u-mrs">Download</span>
                    <i class="c-version__assets-download-icon fa fa-download" aria-hidden="true" />
                  </button>
                </a>
              </a>
              <!-- if project is premium and asset is premium and user is not internal/premium/vip -->
              <a v-if="isPremiumProject && asset.is_premium && (!isPremiumUser && !isInternalUser && !isVipUser)" href="/subscribe/?subscription=upgrade" class="c-version__assets-download-button">
                <button type="button" class="c-button c-button--small">
                  <span class="c-button__label c-version__assets-button-label u-mrs">{{ t('subscribeToDownload') }}</span>
                  <i class="c-version__assets-download-icon fa fa-solid fa-cart-shopping" aria-hidden="true" />
                </button>
              </a>
            </template>
            <!-- if project is premium and asset is not free download -->
            <template v-else>
              <!-- if project is premium, asset download is not authorized, user is not internal/premium/vip -->
              <a v-if="isPremiumProject && !asset.authorized_download && (!isPremiumUser && !isInternalUser && !isVipUser)" href="/subscribe/?subscription=upgrade" class="c-version__assets-download-button">
                <button type="button" class="c-button c-button--small">
                  <span class="c-button__label c-version__assets-button-label u-mrs">{{ t('subscribeToDownload') }}</span>
                  <i class="c-version__assets-download-icon fa fa-solid fa-cart-shopping" aria-hidden="true" />
                </button>
              </a>
              <!-- if project is premium and asset download is authorized -->
              <a v-if="asset.authorized_download && isPremiumProject && (!isPremiumUser && !isInternalUser && !isVipUser)" href="/subscribe/?subscription=upgrade" class="c-version__assets-download-button">
                <button type="button" class="c-button c-button--small">
                  <span class="c-button__label c-version__assets-button-label u-mrs">{{ t('subscribeToDownload') }}</span>
                  <i class="c-version__assets-download-icon fa fa-solid fa-cart-shopping" aria-hidden="true" />
                </button>
              </a>
              <!-- if project is not premium and asset is not premium -->
              <div v-if="asset.authorized_download && !isProtectedProject && !isPremiumProject && !isPremiumAsset" class="c-version__assets-download-container">
                <a :href="assetUrl" class="c-version__assets-download-button matomo_download" download>
                  <button type="button" class="c-button c-button--small" @click="updateDownloadCount">
                    <span class="c-button__label c-version__assets-button-label u-mrs">Download</span>
                    <i class="c-version__assets-download-icon fa fa-download" aria-hidden="true" />
                  </button>
                </a>
              </div>
              <!-- if project is not premium and asset is premium -->
              <a v-if="asset.authorized_download && !isPremiumProject && (isProtectedProject || isPremiumAsset)" href="/subscribe/?subscription=upgrade" class="c-version__assets-download-button">
                <button type="button" class="c-button c-button--small">
                  <span class="c-button__label c-version__assets-button-label  u-mrs">{{ t('subscribeToDownload') }}</span>
                  <i class="c-version__assets-download-icon fa fa-solid fa-cart-shopping" aria-hidden="true" />
                </button>
              </a>
              <!-- if project is premium and asset is not premium -->
              <!-- <div v-if="asset.authorized_download && !isProtectedProject && isPremiumProject && !isPremiumAsset" class="c-version__assets-download-container">
                <a :href="asset.url" class="c-version__assets-download-button" download>
                  <button type="button" class="c-button c-button--small" @click="updateDownloadCount">
                    <span class="c-button__label c-version__assets-button-label u-mrs">Download</span>
                    <i class="c-version__assets-download-icon fa fa-download" aria-hidden="true" />
                  </button>
                </a>
              </div> -->
              <!-- if asset is not authorized, has unlock url, user is not internal/premium/vip -->
              <!-- <Popover v-if="!asset.authorized_download && asset.protection_unlock_url && (!isInternalUser && !isPremiumUser && !isVipUser)" trigger="hover" theme="black" placement="bottom-start">
                <template #button>
                  <a class="u-color-disabled u-no-uline" :href="asset.protection_unlock_url" target="_blank">
                    <SVGIcon class="c-content__icon u-color-dark padlock" name="padlock" color="#505050" />
                  </a>
                </template>
                <template #tooltip>
                  <span class="tooltip-text">{{ t('notAuthorized') }}</span>
                </template>
              </Popover> -->
            </template>
          </template>
        </template>
        <!-- if asset is a url -->
        <template v-else>
          <div class="c-version__assets-download-container">
            <div v-if="isProjectOwner || isAdminUser" class="c-version__assets-data">
              <code class="no-bg">
                <span class="u-color-disabled"> from 2023/02/16: </span>
              </code>
            </div>
            <code v-if="isProjectOwner || isAdminUser" class="c-version__assets-download-count">{{ assetDownloadCount }}</code>
            <!-- if project is premium, user is premium -->
            <a v-if="isPremiumProject && (isPremiumUser && !isInternalUser)" :href="asset.access_url" target="_blank" class="c-version__assets-download-button c-version__assets-url-button matomo_download">
              <button type="button" class="c-button c-button--small" @click="updateUrlDownloadCount">
                <span :class="isPlayUrl(asset.access_url!) ? 'c-version__assets-button-play' : 'u-mrs'" class="c-button__label c-version__assets-button-label">{{ isPlayUrl(asset.access_url!) ? 'Play' : 'Access' }}</span>
                <i class="c-version__assets-download-icon fa-solid fa-arrow-up-right-from-square" aria-hidden="true" />
              </button>
            </a>
            <!-- if project is premium, asset download is not authorized, user is not internal/premium/vip -->
            <a v-if="isPremiumProject && !asset.authorized_download && (!isPremiumUser && !isInternalUser && !isVipUser)" href="/subscribe/?subscription=upgrade" class="c-version__assets-download-button">
              <button type="button" class="c-button c-button--small">
                <span class="c-button__label c-version__assets-button-label u-mrs">{{ t('subscribeToDownload') }}</span>
                <i class="c-version__assets-download-icon fa fa-solid fa-cart-shopping" aria-hidden="true" />
              </button>
            </a>
            <!-- if asset download is authorized, project is protected or premium asset, user is internal/premium/vip -->
            <a v-if="asset.authorized_download && (isProtectedProject || isPremiumAsset) && (isInternalUser || isPremiumUser || isVipUser)" :href="asset.access_url" target="_blank" class="c-version__assets-download-button c-version__assets-url-button matomo_download">
              <button type="button" class="c-button c-button--small" @click="updateUrlDownloadCount">
                <span :class="isPlayUrl(asset.access_url!) ? 'c-version__assets-button-play' : 'u-mrs'" class="c-button__label c-version__assets-button-label">{{ isPlayUrl(asset.access_url!) ? 'Play' : 'Access' }}</span>
                <i class="c-version__assets-download-icon fa-solid fa-arrow-up-right-from-square" aria-hidden="true" />
              </button>
            </a>
            <!-- if asset download is authorized, project is protected or premium asset, user is not internal/premium/vip -->
            <a v-else-if="asset.authorized_download && (isProtectedProject || isPremiumAsset) && (!isInternalUser && !isPremiumUser && !isVipUser)" href="/subscribe" class="c-version__assets-download-button c-version__assets-url-button">
              <button type="button" class="c-button c-button--small">
                <span class="c-button__label c-version__assets-button-label u-mrs">{{ t('subscribeToDownload') }}</span>
                <i class="c-version__assets-download-icon fa fa-solid fa-cart-shopping" aria-hidden="true" />
              </button>
            </a>
            <!-- if asset download is authorized and not premium, project is not premium and not protected -->
            <a v-else-if="asset.authorized_download && !isPremiumAsset && !isPremiumProject && !isProtectedProject" :href="asset.access_url" target="_blank" class="c-version__assets-download-button c-version__assets-url-button matomo_download">
              <button type="button" class="c-button c-button--small" @click="updateUrlDownloadCount">
                <span :class="isPlayUrl(asset.access_url!) ? 'c-version__assets-button-play' : 'u-mrs'" class="c-button__label c-version__assets-button-label">{{ isPlayUrl(asset.access_url!) ? 'Play' : 'Access' }}</span>
                <i class="c-version__assets-download-icon fa-solid fa-arrow-up-right-from-square" aria-hidden="true" />
              </button>
            </a>
            <!-- if asset is not authorized, has unlock url, user is not internal/premium/vip -->
            <!-- <Popover v-else-if="!asset.authorized_download && asset.protection_unlock_url && (!isInternalUser && !isPremiumUser && !isVipUser)" trigger="hover" theme="black" placement="bottom-start">
              <template #button>
                <a class="u-color-disabled u-no-uline" :href="asset.protection_unlock_url" target="_blank">
                  <SVGIcon class="c-content__icon u-color-dark padlock" name="padlock" color="#505050" />
                </a>
              </template>
              <template #tooltip>
                <span class="tooltip-text">{{ t('notAuthorized') }}</span>
              </template>
            </Popover> -->
          </div>
        </template>
        <button v-if="(asset.label || asset.notes)" type="button" class="c-version__assets-toggle-button u-mlxs" @click="toggleAssetInfo">
          <i :class="isAssetInfoVisible ? 'fa-chevron-up' : 'fa-chevron-down'" class="c-version__assets-toggle-icon fa-solid" aria-hidden="true" />
        </button>
        <button v-else type="button" class="c-version__assets-toggle-button c-version__assets-toggle-spacing u-mlxs" />
      </template>
      <!-- if user is not logged in -->
      <template v-else-if="!isLogged">
        <a :href="'/subscribe/?subscription=login&redirect=' + projectUrl" class="c-version__assets-download-button c-version__assets-login-button">
          <button type="button" class="c-button c-button--small">
            <span class="c-button__asset-label">{{ t('loginToDownload') }}</span>
          </button>
        </a>
      </template>
    </div>
    <div v-if="(asset.label || asset.notes) && isAssetInfoVisible" class="c-version__assets-info">
      <div v-if="asset.label" class="c-version__assets-description">{{ asset.label }}</div>
      <div v-if="asset.notes" class="c-version__assets-notes">
        <h4 class="c-version__assets-notes-title">Notes</h4>
        <p>{{ asset.notes }}</p>
      </div>
      <!-- <div v-if="asset.platform" class="c-version__assets-platform">
        <h4 class="c-version__assets-platform-title">{{ t('platform') }}</h4>
        <p>{{ assetPlatformName }}</p>
      </div> -->
    </div>
  </li>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useI18n } from '@/utils/i18n'
import { Asset, getAssetDownload, updateAssetDownloadCounter } from '@/utils/api'
// import SVGIcon from '@/components/SVGIcon.vue'
// import Popover from '@/components/Popover.vue'
import { useAuth } from '@/utils/auth'
import { formatBytes } from '@/utils/format-bytes'

const props = defineProps<{
  asset: Asset
  isPremiumProject?: boolean
  isPremiumUser?: boolean
  isVipUser?: boolean
  isInternalUser?: boolean
  isAdminUser?: boolean
  isProjectOwner?: boolean
  isProtectedProject?: boolean
}>()

// console.log('ASSET: ', props.asset)

const { isLogged } = useAuth()

const isFileAsset = ref(true)

const isPremiumAsset = ref(false)

if (props.asset) {
  if (props.asset.access_url !== null) {
    isFileAsset.value = false
  }
}
// console.log('IS FILE ASSET: ', isFileAsset.value)

const projectUrl = window.location.pathname

const assetUrl = ref(props.asset.url)
if (props.asset.filename) {
  assetUrl.value = '/asset/' + props.asset.pk + '/' + props.asset.filename
} else {
  assetUrl.value = '/asset/' + props.asset.pk + '/' + props.asset.name
}
// console.log('ASSET URL: ', assetUrl.value)

onMounted(() => {
  if (props.asset) {
    if (props.asset.is_premium) {
      isPremiumAsset.value = props.asset.is_premium
    }
  }
  // console.log('IS PREMIUM ASSET: ', isPremiumAsset.value)
})

// get asset download count
const assetDownloadCount = ref(0)
if (isLogged.value) {
  assetDownloadCount.value = (await getAssetDownload(props.asset.pk)).length
}
// console.log('ASSET DOWNLOAD COUNT: ', assetDownloadCount.value)

async function updateUrlDownloadCount () {
  const body = {
    asset: props.asset.pk
  }
  updateAssetDownloadCounter(props.asset.pk, body)
  updateDownloadCount()
}

async function updateDownloadCount () {
  assetDownloadCount.value = (await getAssetDownload(props.asset.pk)).length
  assetDownloadCount.value++
}

function isPlayUrl (url: string): Boolean {
  if (url?.includes('https://play.forum.ircam.fr/') || url?.endsWith('.pd')) {
    return true
  } else {
    return false
  }
}

const isAssetInfoVisible = ref(false)

function toggleAssetInfo () {
  isAssetInfoVisible.value = !isAssetInfoVisible.value
}

const assetPlatformName = ref('')

setPlatformName(props.asset.platform!)

function setPlatformName (name: string) {
  const str = String(name)

  switch (str) {
    case '0':
      assetPlatformName.value = 'macOS'
      break
    case '1':
      assetPlatformName.value = 'Windows'
      break
    case '2':
      assetPlatformName.value = 'Linux'
      break
    case '3':
      assetPlatformName.value = 'Other'
      break
    case '4':
      assetPlatformName.value = ''
      break
    default:
      assetPlatformName.value = ''
      break
  }
}

// setPlatformNameFromAssetName(props.asset.name!)

// function setPlatformNameFromAssetName (name: string) {
//   const str = String(name).toLocaleLowerCase()
//   console.log(str)

//   if (str.includes('mac')) {
//     assetPlatformName.value = 'macOS'
//   } else if (str.includes('win')) {
//     assetPlatformName.value = 'Windows'
//   } else if (str.includes('linux')) {
//     assetPlatformName.value = 'Linux'
//   } else {
//     assetPlatformName.value = 'Other'
//   }
// }

const { t } = useI18n({
  messages: {
    en: {
      subscribeToDownload: 'Subscribe to download',
      loginToDownload: 'Login to download',
      platform: 'Platform',
      unlock: 'unlock the asset',
      notAuthorized: 'You are not authorized to access the file. Click to open the unlock address specified by the project owner.'
    },
    fr: {
      subscribeToDownload: 'S\'abonner pour télécharger',
      loginToDownload: 'Se connecter pour télécharger',
      platform: 'Platforme',
      unlock: 'obtenir l\'asset',
      notAuthorized: "Vous n'êtes pas autorisé à accéder au fichier. Cliquez pour ouvrir le lien de déblocage spécifié par le propriétaire du projet."
    }
  }
})
</script>

<style scoped>
.padlock {
  margin-left: 9px;
  margin-top: 0.2rem;
}

.no-bg {
  background: none;
}

.c-version__assets-toggle-spacing {
  visibility: hidden;
}
</style>
